import React from 'react';
import styles from './Logo.module.scss';
import { useNavigate } from 'react-router';
import Logo1 from './13thstreet/logo.svg?url';
import Logo2 from './syfywire/logo.svg?url';
import Logo3 from './diva/logo.svg?url';
import Logo4 from './dreamworks/logo.svg?url';
import Logo5 from './universal/logo.svg?url';
import Logo6 from './scifiwire/logo.svg?url';
import Logo7 from './13ulica/logo.svg?url';

type LogoKey =
  | '13emerue'
  | '13-ulica'
  | 'diva-universal'
  | 'dwnl'
  | 'sci-fi-poland'
  | 'sci-fi-serbia'
  | 'sci-fi-slovenia'
  | 'syfy'
  | 'unau';

const logos: Record<LogoKey, unknown> = {
  '13emerue': Logo1,
  '13-ulica': Logo7,
  'diva-universal': Logo3,
  dwnl: Logo4,
  'sci-fi-poland': Logo6,
  'sci-fi-serbia': Logo6,
  'sci-fi-slovenia': Logo6,
  syfy: Logo2,
  unau: Logo5,
};

const Logo = (): JSX.Element => {
  const navigate = useNavigate();

  const appName = import.meta.env.VITE_EPGNAME;

  const renderLogo = () => {
    const fallbackLogo = Logo5;
    const logoSrc =
      appName && appName in logos ? logos[appName as LogoKey] : fallbackLogo;

    return (
      <div>
        <img
          className={styles.logo}
          src={logoSrc as string}
          alt=""
          style={{ width: '100px', cursor: 'pointer' }}
        />
      </div>
    );
  };

  return (
    <button
      onClick={() => {
        navigate('/');
        window.location.reload();
      }}
    >
      {renderLogo()}
    </button>
  );
};

export default Logo;
